import styled from 'styled-components';

export const HeroSection = styled.section<{ $reversed?: boolean; $flag?: boolean }>`
  background: ${p =>
    !p.$flag && p.$reversed ? p.theme.token('background-hero-reversed') : 'transparent'};
`;
